<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right">Công ty<span class="required"></span></label>
          <!-- <DropdownScrollable cusClass="text-box m-0" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @click="emitEvent" @keyup="emitEvent" @change="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/> -->
          <DropdownScrollable placeholder="Chọn công ty" cusClass="text-box m-0" width="100%" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @click="emitEvent" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'" @scroll="emitEvent"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right">Tên tiêu chí<span class="required"></span></label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        <div class="mt-3">
          <label class="txt-right">Ký hiệu tiêu chí<span class="required"></span></label>
          <InputText
            v-model="code"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="10"
          />
          <input class="input_tmp_validator" id="code" />
        </div>
        <div class="mt-3">
          <label class="txt-right">XÁC ĐỊNH RỦI RO</label>
        </div>
        <div class="mt-3">
          <label class="txt-right">Mức độ tiêu chí<span class="required"></span></label>
          <InputText
            v-model="name_level"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name_level" />
        </div>
        <div class="mt-3">
          <label class="txt-right">Mô tả mức độ<span class="required"></span></label>
          <Textarea v-model="description_level" :autoResize="true" class="text-box" rows="1" placeholder="Nhập" maxlength="5000"/>
          <input class="input_tmp_validator" id="description_level" />
        </div>
        <div class="mt-3">
          <label class="txt-right">Điểm tiêu chí<span class="required"></span></label>
          <span style="display:flex;">
            <InputNumber v-model="point" class="number-box" placeholder="Nhập"/>
            <Button
              @click="AddLevel()"
              icon="pi pi-plus"
              class="button-box-2 p-button-add"
            />
          </span>
          <input class="input_tmp_validator" id="point" />
        </div>
        <div class="mt-3">
          <table id="tb_level">
            <tr>
              <th style="width: 50px;">STT</th>
              <th>Điểm</th>
              <th>Mức độ tiêu chí</th>
              <th>Mô tả mức độ</th>
              <th style="width: 90px;"></th>
            </tr>
            <tr v-for="(item, index) in criteria_level" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.point}}</td>
              <td>{{item.name}}</td>
              <td>
                <Textarea class="text-area-custom" v-model="item.description" :autoResize="true" disabled/>
              </td>
              <td style="text-align: center;">
                <Button
                  @click="EditItem(index)"
                  icon="pi pi-pencil"
                  class="button-box p-button-edit"
                />
                <Button
                  @click="deleteItem(index)"
                  icon="pi pi-trash"
                  class="button-box p-button-danger"
                />
          </td>
            </tr>
          </table>
        </div>
        <div class="mt-3">
          <Checkbox v-model="active" :binary="true" /> Hiển thị
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
    <Dialog
    style="overflow: auto"
    header="Cập nhật"
    :visible.sync="showEditDialog"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
      <div class="">
        <label class="txt-right">Mức độ tiêu chí<span class="required"></span></label>
        <InputText
          v-model="item_edit.name"
          type="text"
          class="text-box-dialog input-text-box"
          placeholder="Nhập"
        />
        <input class="input_tmp_validator" id="name_level_edit" />
      </div>
      <div class="">
        <label class="txt-right">Mô tả mức độ<span class="required"></span></label>
        <!-- <InputText
          v-model="item_edit.description"
          type="text"
          class="text-box-dialog input-text-box"
          placeholder="Nhập"
        /> -->
        <Textarea v-model="item_edit.description" :autoResize="true" class="text-box-dialog input-text-box" rows="1" placeholder="Nhập" maxlength="5000"/>
        <input class="input_tmp_validator" id="description_level_edit" />
      </div>
      <div class="">
        <label class="txt-right">Điểm tiêu chí<span class="required"></span></label>
        <span style="display:flex;">
          <InputNumber v-model="item_edit.point" class="text-box-dialog" placeholder="Nhập"/>
        </span>
        <input class="input_tmp_validator" id="point_edit" />
      </div>
    <template
      #footer
    >
      <Button label="Lưu" @click="EditData()" icon="pi pi-check" class="" />
      <Button
        label="Hủy"
        @click="showEditDialog = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
    </template>
  </Dialog>
  </form>
  
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  components: {
    DropdownScrollable
  },
  data() {
    return {
      filters: {},
      name: "",
      code: "",
      name_level: "",
      description_level: "",
      point : null,
      criteria_level : [],
      type_login : this.$store.getters.type ? this.$store.getters.type : null,
      criteria_level_deleted : [],
      showEditDialog : false,
      item_edit : {
        name: "",
        description: "",
        point : null,
        index : null
      },
      company : {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      active: true,
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
    };
  },
  async mounted() {
    // await this.getListCompany();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.company = this.model.company;
      this.name = this.model.name;
      this.code = this.model.code;
      // this.criteria_level = this.model.criteria_level;
      var tmp = this.model.criteria_level;
      tmp = this.sortData(tmp,'point')
      for (let i = 0; i < tmp.length; i++) {
        tmp[i].is_old = true
      }
      this.criteria_level = tmp
      this.active = this.model.active;
    }else{
      if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
        await this.getListCompany();
      }else{
        this.company = {id : this.company_id}
      }
    }
  },
  methods: {
    getCompany(value) {
      this.company = value;
    },
    changeOffset(value) {
      this.company_obj.offset = value;
    },
    async emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
              this.company_obj.items.push(...res.data.data.company);
            } else{
              this.company_obj.items = res.data.data.company;
            }
            this.company_obj.total = res.data.data.total;
            this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    EditItem(index){
      const criteria_level = this.criteria_level[index];
      this.item_edit = {
        id : criteria_level.id,
        name: criteria_level.name,
        description: criteria_level.description,
        point : criteria_level.point,
        is_old : criteria_level.is_old,
        index : index
      }
      
      this.showEditDialog = true
    },
    async EditData(){
      if (await this.validateDataEdit()) {
        return;
      }
      if(this.item_edit.index >= 0){
        this.criteria_level[this.item_edit.index] = {
          "id" : this.item_edit.id,
          "name" : this.item_edit.name,
          "description" : this.item_edit.description,
          "point" : this.item_edit.point,
          "is_old" : this.item_edit.is_old
        }
        var tmp = this.criteria_level
        var data = this.sortData(tmp,'point');
        this.criteria_level = data
        this.showEditDialog = false
      }
      
    },
    async AddLevel(){
      //check validate
      if (await this.validateDataAdd()) {
        return;
      }
      var tmp = this.criteria_level
      tmp.push({
        is_old : false,
        id: null,
        name: this.name_level,
        description: this.description_level,
        point: this.point,
      })
      this.name_level= ""
      this.description_level= ""
      this.point = null
      var data = this.sortData(tmp,'point');
      // console.log("data======",data)
      this.criteria_level = data
    },
    sortData(arr,key){
      return arr.slice().sort(function(a, b) {
        return b[key] - a[key];
      });
    },
    async validateDataAdd() {
      let name_level = document.getElementById("name_level");
      if (this.name_level == undefined || this.name_level == null || this.name_level == "") {
        name_level.setCustomValidity("Mức độ tiêu chí không được để trống!");
      } else if (this.name_level.length > 255) {
        name_level.setCustomValidity("Mức độ tiêu chí không được quá 255 ký tự!");
      } else {
        name_level.setCustomValidity("");
      }
      let description_level = document.getElementById("description_level");
      if (this.description_level == undefined || this.description_level == null || this.description_level == "") {
        description_level.setCustomValidity("Mô tả mức độ không được để trống!");
      } else if (this.description_level.length > 5000) {
        description_level.setCustomValidity("Mô tả mức độ không được quá 5000 ký tự!");
      } else {
        description_level.setCustomValidity("");
      }
      let point = document.getElementById("point");
      if (this.point == undefined || this.point == null || this.point == "") {
        point.setCustomValidity("Điểm không được để trống!");
      } else if(this.point <= 0){
        point.setCustomValidity("Điểm phải lớn hơn 0!");
      }else {
        var check_point = false
        for (let i = 0; i < this.criteria_level.length; i++) {
          if(this.point == this.criteria_level[i].point){
            check_point = true;
            break;
          }
        }
        if(check_point == true){
          point.setCustomValidity("Điểm tiêu chí này đã tồn tại!");
        }else{
          point.setCustomValidity("");
        }
        
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async validateDataEdit() {
      let name_level_edit = document.getElementById("name_level_edit");
      if (this.item_edit.name == undefined || this.item_edit.name == null || this.item_edit.name == "") {
        name_level_edit.setCustomValidity("Mức độ tiêu chí không được để trống!");
      } else if (this.item_edit.name.length > 255) {
        name_level_edit.setCustomValidity("Mức độ tiêu chí không được quá 255 ký tự!");
      } else {
        name_level_edit.setCustomValidity("");
      }
      let description_level_edit = document.getElementById("description_level_edit");
      if (this.item_edit.description == undefined || this.item_edit.description == null || this.item_edit.description == "") {
        description_level_edit.setCustomValidity("Mô tả mức độ không được để trống!");
      } else if (this.item_edit.description.length > 5000) {
        description_level_edit.setCustomValidity("Mô tả mức độ không được quá 5000 ký tự!");
      } else {
        description_level_edit.setCustomValidity("");
      }
      let point_edit = document.getElementById("point_edit");
      if (this.item_edit.point == undefined || this.item_edit.point == null || this.item_edit.point == "") {
        point_edit.setCustomValidity("Điểm không được để trống!");
      } else if(this.item_edit.point <= 0){
        point_edit.setCustomValidity("Điểm phải lớn hơn 0!");
      }else {
        var check_point = false
        for (let i = 0; i < this.criteria_level.length; i++) {
          if(this.item_edit.index !== i){
            if(this.item_edit.point == this.criteria_level[i].point){
              check_point = true;
              break;
            }
          }
        }
        if(check_point == true){
          point_edit.setCustomValidity("Điểm tiêu chí này đã tồn tại!");
        }else{
          point_edit.setCustomValidity("");
        }
        
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    deleteItem(index) {
      var criteria_level = this.criteria_level[index];
      if(criteria_level.id){
        this.criteria_level_deleted.push(criteria_level.id)
      }
      this.criteria_level.splice(index, 1)
    },
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};
      if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let name = document.getElementById("name");
      if (this.name == undefined || this.name == null || this.name == "") {
        name.setCustomValidity("Tên tiêu chí không được để trống!");
      } else if (this.name.length > 255) {
        name.setCustomValidity("Tên tiêu chí không được quá 255 ký tự!");
      } else {
        name.setCustomValidity("");
      }
      this.code = this.$commonFuction.replaceAll(this.code,' ','')
      let code = document.getElementById("code");
      if (this.code == undefined || this.code == null || this.code == "") {
        code.setCustomValidity("Kí hiệu tiêu chí không được để trống!");
      } else if (this.code.length > 255) {
        code.setCustomValidity("Kí hiệu tiêu chí không được quá 10 ký tự!");
      } else {
        code.setCustomValidity("");
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if(this.criteria_level.length == 0){
        alert("Vui lòng thêm ít nhất một điểm tiêu chí");
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        company: this.company,
        name: this.name,
        code: this.code,
        criteria_level: this.criteria_level,
        active: this.active
      };
      // console.log("saveData", params);
      this.$emit("save", params);

    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Please upload the image file in the following format: jpeg, jpg, gif, png"
            );
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 1MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === "") {
              this.imagesDeletes.push(this.images[0]);
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.button-box {
  /* min-height: 45px !important; */
  width: 30px !important;
  height: 30px;
  margin-left : 2px;
}
.button-box-2 {
  /* min-height: 45px !important; */
  /* width: 4% !important;
  height: 45px; */
  width : 34px !important;
  margin-left : 6px;
}
.number-box {
  display: block;
  // min-height: 48px !important;
  width: 46% !important;
}
.text-box-dialog {
  display: block;
  // min-height: 48px !important;
  min-width: 400px;
}
.number-text-box {
  padding-top: 11px !important;
  padding-bottom: 11px !important;
  /* padding-left: 10px !important; */
}
/**css table */
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel{
  background: #FFFAF0;
  border: 1px solid #d0dde7;
  color : #000000
}
.text-area-custom:disabled {
  opacity: 1;
  border: none;
}
/**end css table */
</style>
